import { CircularProgress } from '@civilgrid/ui/components';
import { useParams } from '@tanstack/react-router';
import { useGetDataRequest } from '~/hooks/civilsearch/useDataRequest';
import { useGetProject } from '~/hooks/civilsearch/useGetProject';
import type { TProject } from './common';
import Details from './Details';
import ProjectMap from './ProjectMap';

export default function ProjectInfo() {
  const { requestId } = useParams({ strict: false }) as { requestId: string };
  const request = useGetDataRequest({ requestId });
  const project = useGetProject<TProject>({
    projectId: request.data?.project?.id,
  });

  const isLoading = request.isPending || project.isPending;
  const isError = request.isError || project.isError || !project.data;

  if (isLoading) return <CircularProgress indeterminate />;
  if (isError) return <div>An error occurred</div>;

  return (
    <div className="flex h-full w-full grow justify-between">
      <div className="w-1/2 p-2">
        <Details project={project.data} request={request.data} />
      </div>

      <div className="w-1/2 p-2">
        <ProjectMap project={project.data} />
      </div>
    </div>
  );
}
